import React, { Fragment } from "react";
import { lazyWithRetry } from "../../core/lazy_with_retry";

import { OfferingDetailsMultiPass } from "../template_offering_details_multipass";
import { useFoundrSpaceAnalytics } from "./foundrspace_analytics";
import {
  generalInfo,
  partnerConfig,
  testimonials,
} from "./foundrspace_partner_config";

const Theme = lazyWithRetry(() => import("./foundrspace_theme"));

const faqs = [
  {
    question: "What are your hours?",
    answer: "We are open Monday-Friday, 9am-5pm (Closed holidays).",
  },
  {
    question: "Is there somewhere I can make a call or have a meeting?",
    answer:
      "Yes! We have private phone booths you can use for a fee and conference rooms you can book to hold a meeting.",
  },
  {
    question: "Can I cancel my multi-pass order?",
    answer:
      "Unfortunately we do not allow cancellations for the multi-pass but you can cancel and rebook your bookings as you need during the month.",
  },
  {
    question: "When does my multi-pass order expire? ",
    answer: "Your multi-pass order will expire 30 days after purchase.",
  },
];

export function OfferingFoundrSpaceMultiPass() {
  useFoundrSpaceAnalytics();

  return (
    <Fragment>
      <Theme />
      <OfferingDetailsMultiPass
        showAddress={false}
        showDirections
        partnerConfig={partnerConfig}
        data={{
          testimonials: testimonials,
          faqs: faqs,
          generalInfo,
          title: "Multi Pass",
        }}
      />
    </Fragment>
  );
}
